import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  CreateEmpoweredProductLicenseRequest,
  EmpoweredProductLicense,
  EmpoweredProductLicenseResponse,
  GenerateEmpoweredProductLicenseKeyRequest,
  GenerateEmpoweredProductLicenseKeyResponse,
  SetEmpoweredProductLicenseKeyRequest,
  UpdateEmpoweredProductLicenseRequest,
  UpdateEmpoweredProductLicenseStatusRequest,
} from '@models/products-and-orders/requests/empowered-product-license.model';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable()
export class EmpoweredProductLicensesService {
  private readonly baseUrl = `${environment.bffUrl}/empowered-licenses`;

  constructor(private readonly http: HttpClient) {}

  getAll(): Observable<EmpoweredProductLicense[]> {
    return this.http.get<EmpoweredProductLicenseResponse[]>(this.baseUrl);
  }

  getOne(id: string): Observable<EmpoweredProductLicense> {
    return this.http.get<EmpoweredProductLicenseResponse>(`${this.baseUrl}/${id}`);
  }

  create(request: CreateEmpoweredProductLicenseRequest): Observable<EmpoweredProductLicense> {
    return this.http.post<EmpoweredProductLicenseResponse>(this.baseUrl, request);
  }

  update(id: string, request: UpdateEmpoweredProductLicenseRequest): Observable<EmpoweredProductLicense> {
    return this.http.put<EmpoweredProductLicenseResponse>(`${this.baseUrl}/${id}`, request);
  }

  updateStatus(id: string, request: UpdateEmpoweredProductLicenseStatusRequest): Observable<EmpoweredProductLicense> {
    return this.http.post<EmpoweredProductLicenseResponse>(`${this.baseUrl}/${id}/update-status`, request);
  }

  setLicenseKey(id: string, request: SetEmpoweredProductLicenseKeyRequest): Observable<EmpoweredProductLicense> {
    return this.http.post<EmpoweredProductLicenseResponse>(`${this.baseUrl}/${id}/set-license-key`, request);
  }

  delete(id: string): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/${id}`);
  }

  generateLicenseKey(request: GenerateEmpoweredProductLicenseKeyRequest): Observable<GenerateEmpoweredProductLicenseKeyResponse> {
    return this.http.post<GenerateEmpoweredProductLicenseKeyResponse>(`${this.baseUrl}/generate-license-key`, request);
  }
}
